import { render, staticRenderFns } from "./table.vue?vue&type=template&id=cc8a271a&scoped=true&lang=html&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=cc8a271a&lang=scss&scoped=true&"
import style1 from "./table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8a271a",
  null
  
)

export default component.exports